import { MuiSevenGlobalStyles as baseGlobalStyles } from '@curbside-health-inc/theme'

export * from '@curbside-health-inc/theme'
export { cecmDefaultTheme as default } from '@curbside-health-inc/theme'

const { a: anchorStyles, ...rest } = baseGlobalStyles

/**
 * The shared theme paints every `<a>` with the legacy action blue. It is injected
 * through MUI's `<GlobalStyles>`, i.e. emotion, i.e. **unlayered** CSS — and
 * unlayered rules beat anything in a cascade layer no matter how specific. Every
 * Tailwind utility lives in the `utilities` layer, so `text-ink` on a v2
 * component could never win: routed rows in the app shell (`<Link>`, which
 * renders an `<a>`) came out blue while their `<button>` siblings did not.
 *
 * Excluding `.ds-root` descendants hands those anchors back to the design system:
 * classed ones take their utility colour, unclassed ones fall to the
 * `:where(a:not([class]))` accent rule in `@curbside-health-inc/ui/theme.css`.
 * Everything outside a `.ds-root` subtree — i.e. the whole un-migrated MUI app —
 * keeps the old behaviour exactly.
 *
 * This local `export const` intentionally shadows the one re-exported by the
 * `export *` above (an explicit export wins over a star export).
 */
export const MuiSevenGlobalStyles = {
  ...rest,
  'a:not(.ds-root a)': anchorStyles,
}
